import React, { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Lock, Sparkles, Check } from "lucide-react";

const PRO_FEATURES = ["All 15 course modules", "AI Trading Tutor", "Video lessons with TJR"];

export function UpgradePrompt({ title = "This is a Pro feature", description }) {
  const [loading, setLoading] = useState(false);
  const upgrade = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/payments/checkout", { origin_url: window.location.origin });
      window.location.href = data.checkout_url;
    } catch { toast.error("Could not start checkout"); setLoading(false); }
  };
  return (
    <div className="max-w-lg mx-auto text-center py-10" data-testid="upgrade-prompt">
      <div className="w-16 h-16 rounded-2xl bg-blue-500/15 border border-blue-500/25 grid place-items-center mx-auto">
        <Lock className="w-8 h-8 text-blue-400" />
      </div>
      <h2 className="font-display text-2xl font-bold mt-5">{title}</h2>
      <p className="text-slate-400 mt-2 text-sm">{description || "Upgrade to Pro (€3.99/month) to unlock this and much more."}</p>
      <ul className="mt-6 space-y-2 inline-block text-left">
        {PRO_FEATURES.map((f) => (
          <li key={f} className="flex items-center gap-2.5 text-sm text-slate-200"><Check className="w-4 h-4 text-blue-400" />{f}</li>
        ))}
      </ul>
      <div className="mt-7">
        <button data-testid="upgrade-checkout-btn" onClick={upgrade} disabled={loading}
          className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-500 disabled:opacity-60 text-white font-semibold rounded-xl px-7 py-3 transition-colors glow-primary">
          <Sparkles className="w-4 h-4" /> {loading ? "Redirecting…" : "Upgrade to Pro — €3.99/mo"}
        </button>
      </div>
    </div>
  );
}

export default UpgradePrompt;
